import { BrowserRouter } from 'react-router-dom'
import Theme from '@/components/template/Theme'
import Layout from '@/components/layouts'
import { AuthProvider } from '@/auth'
import Views from '@/views'

/**
 * Provider order is load-bearing:
 *
 *   Theme          — the UI kit reads sizing/mode from its context
 *     BrowserRouter — AuthProvider redirects, so it needs a router above it
 *       AuthProvider — Layout picks a layout based on authentication
 *         Layout
 *           Views
 */
function App() {
    return (
        <Theme>
            <BrowserRouter>
                <AuthProvider>
                    <Layout>
                        <Views />
                    </Layout>
                </AuthProvider>
            </BrowserRouter>
        </Theme>
    )
}

export default App
